import { Prompt } from "react-router-dom";
import useFormDirtyHook from "../../shared/hooks/useFormDirtyHook";
import { useTranslation } from "react-i18next";

const LayoutConfirmation = () => {
  const { isFormDirty } = useFormDirtyHook();
  const { t } = useTranslation();

  return <Prompt when={!isFormDirty} message={t("promptMessage")} />;
};

export default LayoutConfirmation;
